// extracted by mini-css-extract-plugin
module.exports = {"description":"QuotazioneGaranziaProtezioneBaseBox_description__tS_hM","list":"QuotazioneGaranziaProtezioneBaseBox_list__GSV6S"};